import type { JSX } from "react";
import type { ValueOrI18nKeyProp } from "../../util/type";
import { Box, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import { bound } from "ecce-react";
import { Copy } from "../../components/atoms/copy";
import { TextButton } from "../../components/atoms/text-button";
import { Prompt } from "../../prompt/prompt";


export type AlertPromptConfig = (
	& Partial<ValueOrI18nKeyProp<"title">>
	& ValueOrI18nKeyProp<"message">
	& Partial<ValueOrI18nKeyProp<"acceptLabel", string>>
);
export class AlertPrompt extends Prompt<void> {
	readonly #config: Readonly<AlertPromptConfig>;

	override view: () => JSX.Element = () => <AlertPromptView prompt={ this }/>;

	constructor(config: AlertPromptConfig) {
		super();
		this.#config = config;
	}

	get title(): string | JSX.Element | null {
		return this.services.translation.resolveValueOrI18nKey(this.#config.title, this.#config.titleKey, this.#config.titleValues, null);
	}

	get message(): string | JSX.Element | null {
		return this.services.translation.resolveValueOrI18nKey(this.#config.message, this.#config.messageKey, this.#config.messageValues);
	}

	get acceptLabel(): string {
		return this.services.translation.resolveValueOrI18nKey(this.#config.acceptLabel, this.#config.acceptLabelKey, this.#config.acceptLabelValues, this.services.translation.translate("common:ok")) as string;
	}

	@bound()
	override submit(): void {
		super.submit(undefined);
	}
}

const AlertPromptView = (p: { prompt: AlertPrompt }): JSX.Element => {
	const title = p.prompt.title;

	return (
		<Box sx={ theme => ({ maxWidth: theme.layout.contentNarrowMaxWidth }) }>
			{ title && <DialogTitle>{ title }</DialogTitle> }
			<DialogContent>
				<Copy>
					{ p.prompt.message }
				</Copy>
			</DialogContent>
			<DialogActions>
				<TextButton
					variant="text"
					label={ p.prompt.acceptLabel }
					onClick={ p.prompt.submit }
					type={ "button" }
				/>
			</DialogActions>
		</Box>
	);
};
